/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('SbfOverviewController', SbfOverviewController);

    SbfOverviewController.$inject = ['$http', 'entity', 'DateUtils'];

    function SbfOverviewController($http, entity, DateUtils) {
        var vm = this;
        vm.project = entity;
        vm.selectAll = false;
        vm.toggle = toggle;
        vm.dataExport = dataExport;

        getOverview();

        function getOverview() {
            $http.get('api/board/sbf-time-slots/overview/', {
                params: {
                    projectId: entity.id,
                    selectAll: vm.selectAll
                }
            }).then(function(response) {
                vm.sbfOverview = response.data;

                for(var i = 0; i < vm.sbfOverview.length; i++) {
                    vm.sbfOverview[i].fromTime = DateUtils.convertDateTimeFromServer(vm.sbfOverview[i].fromTime);
                    vm.sbfOverview[i].toTime = DateUtils.convertDateTimeFromServer(vm.sbfOverview[i].toTime);
                }
            });
        }

        function dataExport() {
            vm.isSaving = true;
            $http.get('api/sbf-time-slots/export/', {
                params: {
                    projectId: entity.id
                }
            }).then(function (response) {
                vm.isSaving = false;
                AlertService.success("Der Export wurde erfolgreich durchgeführt und an deine E-Mail Adresse geschickt.");
            });
        }

        function toggle() {
            vm.selectAll = !vm.selectAll;
            getOverview();
        }
    }
})();
